export default function TestimonialsData() {
  return [
    {
        testimonialID: 1,
        customerInitials: "MT",
        starRating: 5,
        carrierLogoUrl: "https://nbstagingapplicationdata.blob.core.windows.net/public/CarrierLogos/prudential.png",
        customerFirstName: "Maricar",
        customerState: "GA",
        coverageAmount: 500000,
        coverageType: "30 Yr Term",
        monthlyRate: 122.06,
        testimonial: "Very nice people and help what you need. I appreciate them",
        testimonialDate: "2024-04-16T00:00:00",
        createdDate: "2024-07-02T07:10:42.444717",
        updatedDate: "2024-07-02T07:10:42.444717"
    },
    {
        testimonialID: 2,
        customerInitials: "EG",
        starRating: 5,
        carrierLogoUrl: "https://nbstagingapplicationdata.blob.core.windows.net/public/CarrierLogos/pacific-life.png",
        customerFirstName: "Elizabeth",
        customerState: "TX",
        coverageAmount: 500000,
        coverageType: "10 Yr Term",
        monthlyRate: 67.06,
        testimonial: "Darrien was fantastic. She always kept me up to date in terms of progress.",
        testimonialDate: "2024-06-11T00:00:00",
        createdDate: "2024-07-02T07:10:42.444717",
        updatedDate: "2024-07-02T07:10:42.444717"
    },
    {
        testimonialID: 3,
        customerInitials: "KH",
        starRating: 5,
        carrierLogoUrl: "https://nbstagingapplicationdata.blob.core.windows.net/public/CarrierLogos/lga.png",
        customerFirstName: "Kelly",
        customerState: "SC",
        coverageAmount: 250000,
        coverageType: "20 Yr Term",
        monthlyRate: 37.83,
        testimonial: "This process was virtually painless. We appreciate Anna and Darrien for walking us through.",
        testimonialDate: "2024-03-26T00:00:00",
        createdDate: "2024-07-02T07:10:42.444717",
        updatedDate: "2024-07-02T07:10:42.444717"
    },
    {
        testimonialID: 4,
        customerInitials: "SB",
        starRating: 5,
        carrierLogoUrl: "https://nbstagingapplicationdata.blob.core.windows.net/public/CarrierLogos/prudential.png",
        customerFirstName: "Stephen",
        customerState: "GA",
        coverageAmount: 750000,
        coverageType: "20 Yr Term",
        monthlyRate: 246.97,
        testimonial: "My agent was patient and professional.",
        testimonialDate: "2024-04-09T00:00:00",
        createdDate: "2024-07-02T07:10:42.444717",
        updatedDate: "2024-07-02T07:10:42.444717"
    },
    {
        testimonialID: 5,
        customerInitials: "TG",
        starRating: 5,
        carrierLogoUrl: "https://nbstagingapplicationdata.blob.core.windows.net/public/CarrierLogos/lga.png",
        customerFirstName: "Trina",
        customerState: "NC",
        coverageAmount: 300000,
        coverageType: "20 Yr Term",
        monthlyRate: 58.8,
        testimonial: "Painless unlike my previous experience with another agency.",
        testimonialDate: "2024-04-02T00:00:00",
        createdDate: "2024-07-02T07:10:42.444717",
        updatedDate: "2024-07-02T07:10:42.444717"
    },
    {
        testimonialID: 6,
        customerInitials: "HH",
        starRating: 5,
        carrierLogoUrl: "https://nbstagingapplicationdata.blob.core.windows.net/public/CarrierLogos/symetra.png",
        customerFirstName: "Hilary",
        customerState: "ID",
        coverageAmount: 500000,
        coverageType: "20 Yr Term",
        monthlyRate: 88.71,
        testimonial: "Everyone was really nice and accommodating. Thank you!",
        testimonialDate: "2024-03-19T00:00:00",
        createdDate: "2024-07-02T07:10:42.444717",
        updatedDate: "2024-07-02T07:10:42.444717"
    },
    {
        testimonialID: 7,
        customerInitials: "RF",
        starRating: 5,
        carrierLogoUrl: "https://nbstagingapplicationdata.blob.core.windows.net/public/CarrierLogos/protective.png",
        customerFirstName: "Raklim",
        customerState: "CA",
        coverageAmount: 500000,
        coverageType: "IUL",
        monthlyRate: 224.65,
        testimonial: "Customer service was incredible it was all positive energy",
        testimonialDate: "2024-04-09T00:00:00",
        createdDate: "2024-07-02T07:10:42.444717",
        updatedDate: "2024-07-02T07:10:42.444717"
    },
    {
        testimonialID: 8,
        customerInitials: "VB",
        starRating: 4,
        carrierLogoUrl: "https://nbstagingapplicationdata.blob.core.windows.net/public/CarrierLogos/prudential.png",
        customerFirstName: "Victor",
        customerState: "GA",
        coverageAmount: 100000,
        coverageType: "20 Yr Term",
        monthlyRate: 46.99,
        testimonial: "Very satisfied with service",
        testimonialDate: "2024-03-12T00:00:00",
        createdDate: "2024-07-02T07:10:42.444717",
        updatedDate: "2024-07-02T07:10:42.444717"
    },
    {
        testimonialID: 9,
        customerInitials: "AA",
        starRating: 4,
        carrierLogoUrl: "https://nbstagingapplicationdata.blob.core.windows.net/public/CarrierLogos/symetra.png",
        customerFirstName: "Angel",
        customerState: "FL",
        coverageAmount: 250000,
        coverageType: "30 Yr Term",
        monthlyRate: 29.72,
        testimonial: "I didn’t feel forced into getting a policy, I was shopping and was comfortable with the agent I spoke with. He had a lot of knowledge about whatever question I had and I was safe with sharing info with him.",
        testimonialDate: "2024-03-12T00:00:00",
        createdDate: "2024-07-02T07:10:42.444717",
        updatedDate: "2024-07-02T07:10:42.444717"
    },
    {
        testimonialID: 10,
        customerInitials: "KC",
        starRating: 5,
        carrierLogoUrl: "https://nbstagingapplicationdata.blob.core.windows.net/public/CarrierLogos/protective.png",
        customerFirstName: "Kristen",
        customerState: "WA",
        coverageAmount: 250000,
        coverageType: "IUL",
        monthlyRate: 135.31,
        testimonial: "My agent was amazing! Excellent customer service!",
        testimonialDate: "2024-03-12T00:00:00",
        createdDate: "2024-07-02T07:10:42.444717",
        updatedDate: "2024-07-02T07:10:42.444717"
    },
    {
        testimonialID: 11,
        customerInitials: "RH",
        starRating: 5,
        carrierLogoUrl: "https://nbstagingapplicationdata.blob.core.windows.net/public/CarrierLogos/symetra.png",
        customerFirstName: "Randy",
        customerState: "GA",
        coverageAmount: 300000,
        coverageType: "15 Yr Term",
        monthlyRate: 131.12,
        testimonial: "Great customer service",
        testimonialDate: "2024-03-05T00:00:00",
        createdDate: "2024-07-02T07:10:42.444717",
        updatedDate: "2024-07-02T07:10:42.444717"
    },
    {
        testimonialID: 12,
        customerInitials: "JF",
        starRating: 4,
        carrierLogoUrl: "https://nbstagingapplicationdata.blob.core.windows.net/public/CarrierLogos/pacific-life.png",
        customerFirstName: "Jewell",
        customerState: "AZ",
        coverageAmount: 1200000,
        coverageType: "10 Yr Term",
        monthlyRate: 254.59,
        testimonial: "Customer support was great. The inability to share information between multiple applications is obnoxious. I had to fill out new medical information for every application and do the in home medical check for all of them as well.",
        testimonialDate: "2024-03-05T00:00:00",
        createdDate: "2024-07-02T07:10:42.444717",
        updatedDate: "2024-07-02T07:10:42.444717"
    },
    {
        testimonialID: 13,
        customerInitials: "TB",
        starRating: 5,
        carrierLogoUrl: "https://nbstagingapplicationdata.blob.core.windows.net/public/CarrierLogos/protective.png",
        customerFirstName: "Thomas",
        customerState: "MN",
        coverageAmount: 250000,
        coverageType: "10 Yr Term",
        monthlyRate: 77.1,
        testimonial: "All phone contacts very pleasant and professional.",
        testimonialDate: "2024-01-31T00:00:00",
        createdDate: "2024-07-02T07:10:42.444717",
        updatedDate: "2024-07-02T07:10:42.444717"
    },
    {
        testimonialID: 14,
        customerInitials: "RS",
        starRating: 5,
        carrierLogoUrl: "https://nbstagingapplicationdata.blob.core.windows.net/public/CarrierLogos/lga.png",
        customerFirstName: "Ronald",
        customerState: "GA",
        coverageAmount: 500000,
        coverageType: "30 Yr Term",
        monthlyRate: 118.57,
        testimonial: "Service was great, she was very patient especially with me being a shopper and comparing her with other people. She customized a plan for me that nobody else could offer. I will definitely recommend.",
        testimonialDate: "2024-01-18T00:00:00",
        createdDate: "2024-07-02T07:10:42.444717",
        updatedDate: "2024-07-02T07:10:42.444717"
    },
    {
        testimonialID: 15,
        customerInitials: "JC",
        starRating: 5,
        carrierLogoUrl: "https://nbstagingapplicationdata.blob.core.windows.net/public/CarrierLogos/protective.png",
        customerFirstName: "Jeffrey",
        customerState: "NJ",
        coverageAmount: 100000,
        coverageType: "IUL",
        monthlyRate: 117.32,
        testimonial: "It was very easy to do business with agents are awesome",
        testimonialDate: "2024-03-12T00:00:00",
        createdDate: "2024-07-02T07:10:42.444717",
        updatedDate: "2024-07-02T07:10:42.444717"
    }
];
}


// WEBPACK FOOTER //
// ./src/components/Common/Testimonials/TestimonialsData.js